import './Banner.css';

const Banner = ({ lastApp, onExpressBooking, shopName, logoUrl }) => {
    return (
        <section className="banner" id="home">
            <div className="banner-bg"></div>
            <div className="banner-overlay"></div>
            <div className="banner-content">
                <div className="banner-glass-card">
                    <h1 className="banner-title">
                        {logoUrl ? (
                            <img src={logoUrl} alt={shopName} style={{ maxWidth: '280px', maxHeight: '120px', objectFit: 'contain' }} />
                        ) : (
                            <span className="title-top">{shopName || 'SUA BARBEARIA'}</span>
                        )}
                    </h1>
                </div>
                <p className="banner-subtitle">
                    Onde a tradição encontra a excelência e o seu estilo ganha vida.
                </p>

                {lastApp && (
                    <button className="express-book-btn" onClick={onExpressBooking}>
                        <span className="express-icon">⚡</span> REPETIR ÚLTIMO AGENDAMENTO
                    </button>
                )}
            </div>
        </section>
    );
};

export default Banner;
